export default __webpack_public_path__ + "static/media/enslavingfire.be2ac098.png";